import React from 'react';

import PropTypes from 'prop-types';

import { SectionContainer } from 'components/common/Layout/SectionContainer';

import { HELP_INFO_SUPPORTED_COUNTRIES } from 'constants/UrlConstants';

import { getLangCountryPrefix } from 'helpers/utils';

import { useApp, useLanguage } from 'hooks/selectors';

import GeoCountry from './GeoCountry';
import { Countries, Description, LeadText, LearnMore, SectionGeo, ShowAll, Tags, Title } from './styles';
import { LightText } from '../common/fromAuth/LightText/LightText';
import { PromoIcon } from '../common/PromoIcon/PromoIcon';

const Geo = ({ countryFrom, countryTo, localeDependentURI, isRequest, data = {} }) => {
    const { country, isMobileBrowser } = useApp();
    const { lang } = useLanguage();

    const getList = (letters, countries, countryFrom, countryTo) => {
        if (Array.isArray(letters) && letters.length > 0) {
            return letters.map((letter) => {
                const tags = countries.map((country) => {
                    if (country.name.startsWith(letter)) {
                        return (
                            <GeoCountry
                                key={country.code}
                                uri={localeDependentURI}
                                country={country}
                                countryFrom={countryFrom}
                                countryTo={countryTo}
                                onlyMessages={data.onlyMessages}
                                isRequest={isRequest}
                            />
                        );
                    }
                });
                return (
                    <li key={letter}>
                        <Tags>{tags}</Tags>
                    </li>
                );
            });
        } else {
            return null;
        }
    };
    const { title, text, learnMore, letters, countries } = data;
    return (
        <SectionGeo id="com-geography-block-impl" className="no-spinner">
            <SectionContainer dimension={'wide'}>
                <LeadText>
                    <Title>
                        <LightText size={'header'} variant={'h2'}>
                            {title}
                        </LightText>
                    </Title>
                    <Description>
                        <LightText color={'mediumGray'} variant={'paragraph'} dangerouslySetInnerHTML={{ __html: text }} />
                    </Description>
                </LeadText>
                {isMobileBrowser ? null : <Countries>{getList(letters, countries, countryFrom, countryTo)}</Countries>}
                <ShowAll>
                    <a href={`${getLangCountryPrefix(lang, country)}${HELP_INFO_SUPPORTED_COUNTRIES}`}>
                        <LearnMore>
                            <LightText color={'purple'}>{learnMore}</LightText>
                        </LearnMore>
                        <PromoIcon name="chevron-right" size="24px" color="primary" />
                    </a>
                </ShowAll>
            </SectionContainer>
        </SectionGeo>
    );
};
Geo.propTypes = {
    localeDependentURI: PropTypes.string.isRequired,
    data: PropTypes.shape({
        title: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
        learnMore: PropTypes.string.isRequired,
        letters: PropTypes.arrayOf(PropTypes.string).isRequired,
        countries: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string.isRequired,
                code: PropTypes.string.isRequired,
            }),
        ).isRequired,
    }),
};
export default Geo;
